module.exports = __webpack_public_path__ + "static/media/right_arrow-512.3724e527.svg";